'use client';

// FormStyles.js - Consistent form styling components for the application

// Input field styling
export const inputClass = "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg text-black";

// Label styling
export const labelClass = "block text-base font-medium text-gray-800";

// Form container styling
export const formContainerClass = "bg-white shadow-lg px-6 py-8 sm:rounded-xl sm:p-8 border border-gray-200";

// Error message styling
export const errorContainerClass = "mb-6 bg-red-50 border-l-4 border-red-400 p-4 rounded-md shadow-sm";

// Button styling - Primary
export const primaryButtonClass = "inline-flex justify-center py-3 px-6 border border-transparent shadow-md text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 transition-colors duration-200";

// Button styling - Secondary
export const secondaryButtonClass = "bg-white py-3 px-6 border border-gray-300 rounded-lg shadow-md text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200";

// Section heading styling
export const sectionHeadingClass = "text-xl font-medium leading-6 text-gray-900 mt-8 mb-2";

// Section description styling
export const sectionDescriptionClass = "mt-1 text-sm text-gray-500 mb-4";

// Checkbox container styling
export const checkboxContainerClass = "flex items-start bg-gray-50 p-4 rounded-lg border border-gray-200";

// Form group spacing
export const formGroupClass = "space-y-8";

// Form field container
export const fieldContainerClass = "mt-2";

// Textarea styling
export const textareaClass = "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg text-black";

// Card styling for grouped form elements
export const cardClass = "border border-gray-200 rounded-lg p-6 shadow-sm bg-white mb-4";
